import { render, staticRenderFns } from "./AddWarehouseLocation.vue?vue&type=template&id=56e2c7fe&"
import script from "./AddWarehouseLocation.vue?vue&type=script&lang=js&"
export * from "./AddWarehouseLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports